<template>
  <section class="section hero-section">
    <div class="hero-container wrapper">
      <img
        src="./../assets/hero.webp"
        class="hero-main-image"
        alt="Hero illustration"
      />

      <div class="left">
        <div class="title large weight-900">{{ $t("Unlock Your Own") }}</div>
        <div class="desc desc-20 weight-500">
          {{ $t("Claim a personal island.") }}
        </div>
      </div>
      <div class="right">
        <div class="title title-96 weight-900">
          {{ $t("Minecraft Realm!") }}
        </div>
        <div class="desc desc-20 weight-500">
          {{ $t("Build the empire you’ve always imagined.") }}
        </div>
      </div>

      <button
        class="hero-button button secondary"
        @click="$emit('scrollToPrice')"
      >
        <span>{{ $t("BUY NOW") }}</span>
      </button>

      <ScrollButton class="hero-scroll" @click="$emit('scrollNextSection')" />
    </div>
  </section>
</template>

<script>
import { defineComponent } from "vue";
import ScrollButton from "@/components/ScrollButton.vue";
import SoundToggle from "@/components/SoundToggle.vue";

export default defineComponent({
  name: "HeroSection",

  components: {
    ScrollButton,
    SoundToggle,
  },

  setup() {
    const paymentMethods = [
      { name: "Visa", icon: require("@/assets/visa.svg") },
      { name: "Mastercard", icon: require("@/assets/mastercard.svg") },
      { name: "3D Secure", icon: require("@/assets/3ds.png") },
    ];

    return {
      paymentMethods,
    };
  },
});
</script>

<style lang="scss" scoped>
.hero-container {
  flex-direction: column;
  align-items: center;
}

.hero-main-image {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 942px;
  height: auto;
  z-index: 1;
  pointer-events: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.hero-heading {
  width: 100%;
  color: #fff;
}

.hero-heading-primary {
  font-size: 160px;
  line-height: 200px;
  font-weight: 700;
  text-align: left;
}

.hero-heading-secondary {
  position: absolute;
  top: 126px;
  right: 0;
  font-size: 160px;
  line-height: 200px;
  font-weight: 700;
  text-align: right;
  z-index: 2;
}

.hero-description {
  margin-top: 84px;
  max-width: 290px;
  font-size: 16px;
  line-height: 20px;
  text-align: right;
  font-weight: 400;
  align-self: flex-start;
  z-index: 2;
}

.hero-button {
  margin-top: 190px;
  max-width: 250px;
  width: 100%;
  z-index: 2;
}

.hero-scroll {
  z-index: 2;
  position: absolute;
  right: 0;
  bottom: 0;
}

.hero-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 19px;
  z-index: 2;
}

.hero-payment {
  display: flex;
  align-items: center;
  gap: 17px;
}

.hero-payment-icon {
  height: 24px;
  width: auto;
}

/* Tablet styles */
@media (max-width: 1024px) {
  .hero-heading-primary,
  .hero-heading-secondary {
    font-size: 120px;
    line-height: 150px;
  }

  .hero-heading-secondary {
    top: 276px;
  }

  .hero-tagline {
    font-size: 28px;
    line-height: 36px;
    max-width: 320px;
  }

  .hero-main-image {
    max-width: 560px;
  }
}

/* Mobile styles */
@media (max-width: 768px) {
  .hero {
    padding: 20px;
    min-height: 800px;
  }

  .hero-heading-primary,
  .hero-heading-secondary {
    font-size: 64px;
    line-height: 80px;
    text-align: center;
  }

  .hero-heading-secondary {
    position: relative;
    top: 0;
    margin-top: 20px;
  }

  .hero-tagline {
    position: relative;
    top: 0;
    font-size: 24px;
    line-height: 32px;
    max-width: 100%;
    text-align: center;
    margin-bottom: 40px;
  }

  .hero-main-image {
    position: relative;
    top: 0;
    left: 0;
    transform: none;
    max-width: 100%;
    margin: 40px 0;
  }

  .hero-description {
    margin-top: 40px;
    text-align: center;
    max-width: 100%;
    align-self: center;
  }

  .hero-button {
    margin-top: 40px;
  }

  .hero-scroll {
    margin-top: 40px;
    position: static;
  }

  .hero-footer {
    flex-direction: column;
    gap: 20px;
  }

  .hero-payment {
    justify-content: center;
    width: 100%;
  }

  .hero-sound {
    margin-top: 20px;
  }
}

/* Small mobile styles */
@media (max-width: 480px) {
  .hero-heading-primary,
  .hero-heading-secondary {
    font-size: 48px;
    line-height: 60px;
  }

  .hero-tagline {
    font-size: 20px;
    line-height: 28px;
  }

  .hero-payment-icon {
    height: 20px;
  }
}
</style>
